import {Component, Input, ViewChild} from "@angular/core";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {NgClass} from "@angular/common";

@Component({
    standalone: true,
    selector: 'app-full-page-spinner',
    templateUrl: './full-page-spinner.component.html',
    imports: [
        MatProgressSpinnerModule,
        NgClass
    ],
    styleUrls: ['./full-page-spinner.component.scss']
})
export class FullPageSpinnerComponent {
    @Input() opaque: boolean;

    @ViewChild('spinner') spinner: HTMLElement;

}
